/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandFlutter = createReactComponent("brand-flutter", "IconBrandFlutter", [
  ["path", { d: "M7 14l-3 -3l8 -8h6z", key: "svg-0" }],
  ["path", { d: "M14 21l-5 -5l5 -5h5l-5 5l5 5z", key: "svg-1" }]
]);

export { IconBrandFlutter as default };
//# sourceMappingURL=IconBrandFlutter.js.map
